import { Dialog } from "@syncfusion/ej2-popups";

export const DIALOG_ID = 'schedule-dialog';

export function closeSchedulePopupDialog() {
    const createPopup = document.getElementById(DIALOG_ID) as HTMLElement;
    var element: any = createPopup;
    var ej2 = element.ej2_instances[0] as Dialog;
    ej2.hide();
}

export function openScheduleDialog()
{
    const createPopup = document.getElementById(DIALOG_ID) as HTMLElement;
    var element: any = createPopup;
    var ej2 = element.ej2_instances[0] as Dialog;
    ej2.show(true);
}
            
export function getPrice(query: string, target: string)
{
    const htmx = (window as any).htmx;
    htmx.ajax('GET', '/sales/cal-price?'+query, {
        target: '#'+target,
        headers: {
            'HX-Component': 'true'
        }
    });
}

export function updateLinkedAutoCompleteFieldValue(fieldId: string, value: string) {
    const inputEle = document.getElementById("input_" + fieldId) as HTMLElement;
    var element: any = inputEle;
    var ej2 = element.ej2_instances[0];
    ej2.value = value;
}

export interface PersonBooking {
    firstName: string,
    lastName: string,
    phone: string,
    email: string,
    personId?: string,
}

export interface Booking {
    person: PersonBooking,
    startDate: string,
    endDate: string, 
    rooms: [],
    programOnly: []
}
